// Statistics → Parcels (parcel tracking v2, Claude, 2026-10-02 — moved here from Warehouse → Parcels at
// Fernando's request). Two tabs, each its own URL so a link lands on the right one:
//   /statistics/parcels/states     — Shipping states: where each parcel is, the action list (everyone)
//   /statistics/parcels/dashboard  — Dashboard: delivery times per carrier / country, days and workdays
// Open to every role, as the Parcels page was; the numbers are the connector's too (parcel_report.py).
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { authFetch, API } from '../api';
import ShippingStates from './ShippingStates';
import ParcelDashboard from './ParcelDashboard';

const VIEWS: [string, string][] = [['states', 'Shipping states'], ['dashboard', 'Dashboard']];

export default function ParcelsSection() {
  const { view = 'states' } = useParams<{ view: string }>();
  const navigate = useNavigate();
  const [webshops, setWebshops] = useState<{ id: string; name: string }[]>([]);
  useEffect(() => {
    authFetch(`${API}/settings/webshops`).then(async r => { if (r.ok) setWebshops(await r.json()); }).catch(() => {});
  }, []);
  const v = VIEWS.some(([k]) => k === view) ? view : 'states';

  return (
    <div className="p-3 md:p-6 max-w-[1500px]">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-white">Parcels</h1>
        <p className="text-gray-500 text-sm mt-0.5">
          Every shipped parcel from the carriers' own tracking — where it is now, and how long delivery takes.
        </p>
      </div>
      <div className="flex gap-1 border-b border-gray-800 mb-5">
        {VIEWS.map(([k, label]) => (
          <button key={k} onClick={() => navigate(`/statistics/parcels/${k}`)}
            className={`px-4 py-2 text-sm font-medium rounded-t-lg transition-colors ${
              v === k ? 'text-white border-b-2 border-blue-500' : 'text-gray-400 hover:text-white'}`}>
            {label}
          </button>
        ))}
      </div>
      {v === 'states' ? <ShippingStates webshops={webshops} /> : <ParcelDashboard webshops={webshops} />}
    </div>
  );
}
